import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const result = `
    data {
      codigo
      master
      status
      dataCadastro
      descricao
      unidade
      intervalo
      antecipacao
      tipoAntecipacao
      tipoManutencao
    }
    totalRecords`;

const MAINTENANCE_PLANS_REQUESTS = gql`
    query GetMaintenancePlans ($limit: Int! $offset: Int!) {
        maintenancePlans(limit: $limit, offset: $offset) {
            ${result}
        }
    }
  `;

export const getAllMaintenancePlans = async () => {
    
        const response = await queryAllPages(client, {
            query: MAINTENANCE_PLANS_REQUESTS,
            variables: {
                limit: 1000,
                offset: 0,
            }
        });
        const { data } = response.data.maintenancePlans;
        return data;
    
}
